export const crystalReportConstants = {
  BASE_PATH: '/v1/crystal_reports',
  GET_CRYSTAL_REPORTS: 'GET_CRYSTAL_REPORTS',
  SET_CRYSTAL_REPORTS_LOADING: 'SET_CRYSTAL_REPORTS_LOADING',
};
